module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "solution-menu"
  }, [_vm._l((_vm.items), function(item, i) {
    return [_c('SolutionsButton', {
      key: 'button' + i,
      attrs: {
        "item": item,
        "isActive": _vm.selected == item.name
      },
      on: {
        "setActive": function($event) {
          _vm.setActive(item.name)
        },
        "toggleActive": function($event) {
          _vm.toggleActive(item.name)
        }
      }
    }), _vm._v(" "), _c('SolutionsContent', {
      key: 'content' + i,
      attrs: {
        "item": item,
        "isActive": _vm.selected == item.name
      }
    })]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a34706fa","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=2orvgp80z9y!./~/string-replace-webpack-plugin/loader.js?id=fk6phdenes7!./src/components/hub/RaHubSolutions.vue
// module id = 711
// module chunks = 0